export default {
  // General
  save: "Enregistrer",
  saving: "Enregistrement",
  cancel: "Annuler",
  edit: "modifier",
  delete: "Supprimer",
  profile: "Profil",
  settings: "Paramètres",
  logout: "Déconnexion",
  language: "Langue",
  loading: "Chargement",
  submit: "Soumettre",
  search: "Rechercher...",
  back: "Retour",
  next: "Suivant",
  previous: "Précédent",
  continue: "Continuer",
  done: "Terminé",
  error: "Erreur",
  success: "Succès",
  warning: "Avertissement",
  info: "Information",
  close: "Fermer",
  open: "Ouvrir",
  yes: "Oui",
  no: "Non",
  ok: "OK",
   
  // Profile specific
  memberSince: "Membre depuis",
  streak: "Série",
  xp: "XP",
  pro: "Pro",
  free: "Gratuit",
  recentActivity: "Activité Récente",
  noSetsYet: "Pas Encore d'Ensembles :(",
  upgradeToPro: "Passer à Pro",
  recentActivity: "Activité Récente",
  shareWithAFriend: "Partager avec un Ami",
  contactTheTeam: "Contacter l'Équipe",
  termsAndConditions: "Conditions Générales",
  editUsername: "Modifier le Nom d'Utilisateur :",
  logOut: "Déconnexion",
  usernameError1: "Le nom d'utilisateur ne peut pas être vide",
  usernameError2: "Veuillez entrer un nom d'utilisateur différent ou nouveau",
  usernameError3: "Le nom d'utilisateur ne peut pas contenir d'espaces",
  usernameError4: "Le nom d'utilisateur ne peut pas contenir de lettres majuscules",
  usernameError5: "Le nom d'utilisateur ne peut pas contenir de caractères spéciaux",
  usernameError6: "Le nom d'utilisateur doit comporter entre 4 et 18 caractères",
  usernameError7: "Le nom d'utilisateur contient du contenu inapproprié",
  usernameError8: "Ce nom d'utilisateur est déjà pris",
  clickOrDragAndDrop: "Cliquez ou faites glisser et déposez pour télécharger",
  confirm: "Confirmer",
  retake: "Réessayer",

  // BottomNav
  profile: "Profil",
  home: "Accueil",
  library: "Ma Bibliothèque",
  saved: "Enregistré",
  rankings: "Classements",

  // Feature
  backToLibrary: "Retour à la Bibliothèque",
  exploreSets: "Explorer les Ensembles",
  communitySets: "Ensembles de la Communauté",
  mySets: "Mes Ensembles",
  alreadyAdded: "Déjà Ajouté",
  addToLibrary: "Ajouter à la Bibliothèque",
  loading: "Chargement...",
  loadMoreSets: "Charger Plus d'Ensembles",
  by: "Par",
  makePublic: "Rendre Public",
  subscriptionRequired: "Abonnement Requis",
  subscriptionRequiredMessage: "Vous ne pouvez avoir que 10 ensembles à la fois dans la bibliothèque. Mettez à niveau vers pro pour des ensembles illimités !",

  // My Library
  deleteSet: "Supprimer l'Ensemble",
  deleteSetConfirmation: "Êtes-vous sûr de vouloir supprimer cet ensemble ?",
  yesDelete: "Oui, Supprimer",
  collections: "Ensembles Publics",
  myLibrary: "Ma Bibliothèque",
  outOf10Sets: "sur 10 ensembles ajoutés.",
  switchBackToPro: "Revenir à Pro",
  upgradeToPro: "Mettre à niveau vers Pro",
  outOf10OnFree: "sur 10 gratuits.",
  letMeCook: "Laissez-moi cuisiner",
  selectMode: "Sélectionner le Mode",
  multipleChoice: "Choix Multiple",
  flashcards: "Cartes à Repérer",
  freeResponse: "Réponse Libre",
  proOnly: "Pro Only",
  leaderboard: "Classement",
  favorites: "Favoris",
  profile: "Profil",
  reportBugs: "Signaler des Erreurs",

  // Question Card
  correctMessage: "Correct! Vous Avez Cuisiné.",
  typeYourAnswer: "Écrivez votre réponse ici...",
  submitAnswer: "Soumettre la Réponse",
  responseCannotBeBlank: "La réponse ne peut pas être vide",
  noAnswerAvailable: "Aucune réponse disponible",
  answerGuideline: "Directives de Réponse",
  pleaseSubmitAnswerFirst: "Veuillez soumettre votre réponse en premier",
  revealAnswer: "Révéler la Réponse",
  hideAnswer: "Masquer la Réponse",
  gradingInProgress: "Notation en cours...",
  grading: "Notation",
  answerGuidelines: "Directives de Réponse",
  finalScore: "Score Final:",
  evaluateAnswer: "Évaluer la Réponse",

  // Saved
  favorites: "Favoris",
  searchQuestions: "Rechercher des questions...",
  noSavedQuestions: "Aucune question enregistrée pour le moment.",

  // Scroller
  loadingMoreQuestions: "Chargement de Plus de Questions",

  // New Prompt
  deleteSet: "Supprimer l'Ensemble",
  deleteSetConfirmation: "Êtes-vous sûr de vouloir supprimer cet ensemble ?",
  yesDelete: "Oui, Supprimer",
  cancel: "Annuler",
  setLimitReached: "Limite d'Ensemble Atteinte",
  setLimitError: "Vous ne pouvez avoir que 10 ensembles à la fois dans la bibliothèque. Mettez à niveau vers Pro pour des ensembles illimités !",
  close: "Fermer",
  uploadNotes: "Télécharger des Notes",
  general: "Général",
  title: "Titre",
  setTitleMessage: "Donnez un titre à vos questions Cookr générées par IA, pour qu'elles soient faciles à accéder plus tard.",
  titleError1: "Le titre ne peut pas être vide",
  titleError2: "Le titre contient du contenu inapproprié",
  content: "Contenu",
  setContentMessage: "Copiez et collez vos notes, conférences ou tout autre contenu textuel.",
  contentError1: "Le contenu ne peut pas être vide",
  contentError2: "Le contenu contient du contenu inapproprié",
  subject: "Sujet",
  setSubjectMessage: "Quel est le sujet ou le thème de ce contenu?",
  subjectError1: "Le sujet ne peut pas être vide",
  subjectError2: "Le sujet contient du contenu inapproprié",

  // Payment Confirmation
  returnToProfile: "Retour au Profil",

  // Plans
  confirmSwitch: "Confirmer le Passage au Plan Gratuit",
  confirmSwitchMessage: "Êtes-vous sûr de vouloir passer au Plan Gratuit ? Vous perdrez l'accès aux fonctionnalités premium.",
  buttonConfirm: "Confirmer le Passage",
  processing: "Traitement...",
  unlimitedScrolling: "Défilement Illimité",
  unlimitedSubjects: "Sujets Illimités",
  aiTutorBot: "Bot de Tutorat AI",
  newFeatureAccess: "Accès aux Nouvelles Fonctionnalités",
  saveScrolls: "Enregistrer les Scrolls",
  infiniteNoteUploads: "Téléchargements de Notes Illimités",
  answerExplanations: "Explications des Réponses",
  shareScrolls: "Partager les Scrolls",
  everythingInStandard: "Tout dans le Standard",
  current: "Actuel",
  switchOver: "Passer à",
  forever: "/pour toujours",
  monthly: "/par mois",
  yearly: "/par an",

  // Leaderboard
  leaderboard: "Classement",

  // Home.js
  pickASubject: "Choisissez un sujet pour commencer votre session !",

  // scrollerLoader
  generatingContent: "Génération du Contenu...",

  // Dropdown
  choose: "Choisir",
  titleTooLong: "Le titre ne peut pas contenir plus de 100 caractères",
}

